/*  
    这是动态路由配置模块
    首先加载路由包
    然后加载各个使用到路由的模块，
 */


//import {BrowserRouter as Router,Route,Link} from 'react-router-dom';
import {
    HashRouter as Router, // 或者是HashRouter、MemoryRouter
    Route,   // 这是基本的路由块
    Link,    // 这是a标签
    Switch ,  // 这是监听空路由的
    Redirect, // 这是重定向
    Prompt   // 防止转换
} from 'react-router-dom'

import MIFA from '../components/MIFAs/MIFA';
import MifaIntro from '../components/MIFAs/MifaIntro';
import Correlation from '../components/MIFAs/Correlation';

import HCC from '../components/HCCs/HCC';
import HccCalIntro from '../components/HCCs/HccCalIntro';
import HccCalCalculation from '../components/HCCs/HccCalCalculation';
import LDEval from '../components/HCCs/LDevaluation';
import LDIntro from '../components/HCCs/LDIntro';

import HCCchi from '../components/HCCsChi/HCCchi';
import HccCalIntroChi from '../components/HCCsChi/HccCalIntroChi';
import HccCalCalculationChi from '../components/HCCsChi/HccCalCalculationChi';
import LDEvalChi from '../components/HCCsChi/LDevaluationChi';
import LDIntroChi from '../components/HCCsChi/LDIntroChi';



import Welcome from '../components/Welcome';
import Continue from '../components/Continue';
import WelChinese from '../components/WelChinese';
//import Mobile from '../components/Mobile/Mobile';

import Bicomb from '../components/Bicombs/Bicomb';
import DownloadBicomb from '../components/Bicombs/Download';

import Contact from '../components/Contact/Contact';
import Director from '../components/Contact/Director';
import Member from '../components/Contact/Member';
import Graduates from '../components/Contact/Graduates';
import InternDoctors from '../components/Contact/intern-doctor';
import BlindedReview from '../components/Contact/BlindedReview';

import ClarityICI from '../components/ClarityICI/ClarityICI';
import ClarityICIAll from '../components/ClarityICI/ClarityICIAll';
import ClarityICIWestern from '../components/ClarityICI/ClarityICIWestern';
import ClarityICIEastAsian from '../components/ClarityICI/ClarityICIEastAsian';
import ClarityICIIntroAnn from '../components/ClarityICI/ClarityICIIntroAnn';

import irAEs from '../components/irAEs/irAEs';
import irAEsModel from '../components/irAEs/irAEsModel';
import PneumonitisModel from '../components/irAEs/PneumonitisModel';
import severeModel from '../components/irAEs/severeModel';
import Diameter from '../components/Diameter/Diameter';

let routes=[
    {
        path:"/",
        component:Welcome,
        exact:true,
    },
    {
        path:"/mifa",
        component:MIFA,
    },
    {
        path:"/hcc",
        component:HCC,
    },
    {
        path:"/bicomb",
        component:Bicomb,
    },
    {
        path:"/continue",
        component:Continue,
    },
    {
        path:"/clarityICI",
        component:ClarityICI,
    },
    {
        path:"/clarityICIAll",
        component:ClarityICIAll,
    },
    {
        path:"/clarityICIWestern",
        component:ClarityICIWestern,
    },
    {
        path:"/clarityICIEastAsian",
        component:ClarityICIEastAsian,
    },
    {
        path:"/clarityICIIntroAnn",
        component:ClarityICIIntroAnn,
    },
    {
        path:"/irAEs",
        component:irAEs,
    },
    {
        path:"/irAEsModel",
        component:irAEsModel,
    },
    {
        path:"/severeModel",
        component:severeModel,
    },
    {
        path:"/PneumonitisModel",
        component:PneumonitisModel,
    },
    {
        path:"/Diameter",
        component:Diameter,
    },
    /*{
        path:"/mobile",
        component:Mobile,
    },
    */
    {
        path:"/contact",
        component:Director, /*由 Director 改为 BlindedReview------------2020.9.28 由BlindedReview改为Director*/  
        
    },
    {
        path:"/BlindedReview",
        component:BlindedReview
    },
    {
        path:"/director",
        component:Director,
    },
    {
        path:"/graduates",
        component:Graduates,
    },
    {
        path:"/member",
        component:Member,
    },
    {
        path:"/intern-doctors",
        component:InternDoctors,
    },
    {
        path:"/hcc-cal-introduction",
        component:HccCalIntro,
    },
    {
        path:"/hcc-cal-calculation",
        component:HccCalCalculation,
    },
    {
        path:"/hcc-ld-evaluation",
        component:LDEval,
    },
    {
        path:"/hcc-ld-introduction",
        component:LDIntro,
    },


    {
        path:"/mifa-correlation",
        component:Correlation,
    },
    {
        path:"/mifa-intro",
        component:MifaIntro,
    }, 
    {
        path:"/Chinese",
        component:WelChinese,
    }, 
    {
        path:"/hcc-chi",
        component:HCCchi,
    }, 
    {
        path:"/hcc-ld-introduction-chi",
        component:LDIntroChi,
    }, 
    {
        path:"/hcc-ld-evaluation-chi",
        component:LDEvalChi,
    }, 
    {
        path:"/hcc-cal-introduction-chi",
        component:HccCalIntroChi,
    }, 
    {
        path:"/hcc-cal-calculation-chi",
        component:HccCalCalculationChi,
    }, 
 

]
export default routes;